import filterConstants from '../constants';

const reportsTimeResource = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsTimeResource,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
    [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    [filterConstants.PROPERTY.assignee]: '',
  },
});

export default reportsTimeResource;
